var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
		'window-view': 	true,
		shake: 			_vm.shaking
	},style:({ width: `${_vm.width}px`, marginLeft: `-${_vm.width / 2}px` })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"shield"}),_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"corner"},[_c('svg-icon',{class:{
					icon: 		true,
					close:		_vm.icon == 'cross',
					loading: 	_vm.loading
				},attrs:{"icon":_vm.icon},on:{"click":function($event){$event.stopPropagation();return _vm.iconClick.apply(null, arguments)}}}),_c('half-circle-spinner',{class:{
					loader: 	true,
					loading: 	_vm.loading
				},attrs:{"animation-duration":1000,"size":20,"color":"#ff5723"}})],1)]),_c('div',{class:{
				body:		true,
				loading: 	_vm.loading
			}},[_vm._t("default")],2),_c('div',{class:{
				footer:		true,
				loading: 	_vm.loading
			}},_vm._l((_vm.actions),function(a,i){return _c('button-view',_vm._b({key:i,staticClass:"action",on:{"click":function($event){$event.stopPropagation();return _vm.action(a.action)}}},'button-view',a,false),[_vm._v(_vm._s(a.label))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }